import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { FiatTransaction as OldFiatTransactionModel } from "@models/transaction";
import { DateTime } from "@modules/+new/transactions/domain/entities/date-time.model";
import {
	TransactionTag,
	TransactionTagAdapter
} from "@modules/+new/transactions/domain/entities/transaction-tag.model";
import { FiatTransactionDto } from "@modules/+new/transactions/infrastructure/dto/fiat-transaction.dto";

export interface FiatTransaction {
	readonly id: string;
	readonly fiatWalletId: string;
	readonly fiatId: string;
	readonly amount: number;
	readonly fee: number;
	readonly time: DateTime;
	readonly inOrOut: string; // TODO add enum
	readonly type: string; // TODO add enum
	readonly status: string; // TODO add enum
	readonly confirmationBy?: string;
	readonly isConfirmed: boolean;
	readonly paymentOptionId: string;
	readonly requires2faApproval: boolean;
	readonly paymentUrl: string;
	readonly isSavings: boolean;
	readonly lastChanged: DateTime;
	readonly tags: TransactionTag[];
	readonly isIndex: boolean;
	readonly isCard: boolean;
}

export class FiatTransactionAdapter extends BaseAdapter<OldFiatTransactionModel, FiatTransaction> {
	private readonly transactionTagAdapter = new TransactionTagAdapter();
	public adapt(item: OldFiatTransactionModel): FiatTransaction | null {
		if (!item) {
			return null;
		}

		return {
			id: item.getId(),
			fiatWalletId: item.getFiatWalletId(),
			fiatId: item.getFiatId(),
			amount: item.getAmount(),
			fee: item.getFee(),
			time: {
				dateIso8601: item.getTime().getDate(),
				unix: item.getTime().getUnix()
			},
			inOrOut: item.getInOrOut(),
			type: item.getType(),
			status: item.getStatus(),
			confirmationBy: null, // TODO unavailable to get from old model directly
			isConfirmed: item.isConfirmed(),
			paymentOptionId: item.getPaymentOptionId(),
			requires2faApproval: item.needsPinConfirmation(),
			paymentUrl: item.getPaymentLink(),
			isSavings: item.isSavings,
			lastChanged: {
				dateIso8601: item.getLastChanged().getDate(),
				unix: item.getLastChanged().getUnix()
			},
			tags: this.transactionTagAdapter.adaptMany(item.getTransactionTags()),
			isIndex: item.isIndex(),
			isCard: item.isCard()
		};
	}
}

export class FiatTransactionDtoAdapter extends BaseAdapter<FiatTransactionDto, FiatTransaction> {
	public adapt(item: FiatTransactionDto): FiatTransaction | null {
		if (!item) {
			return null;
		}

		return {
			id: item.id,
			fiatWalletId: item.fiat_wallet_id,
			fiatId: item.fiat_id,
			amount: +item.amount,
			fee: +item.fee,
			time: {
				dateIso8601: item.time.date_iso8601,
				unix: +item.time.unix // TODO verify and test
			},
			inOrOut: item.in_or_out,
			type: item.type,
			status: item.status,
			confirmationBy: item.confirmation_by,
			isConfirmed: item.confirmed,
			paymentOptionId: item.payment_option_id,
			requires2faApproval: item.requires_2fa_approval,
			paymentUrl: item.payment_url,
			isSavings: item.is_savings,
			lastChanged: {
				dateIso8601: item.last_changed.date_iso8601,
				unix: +item.last_changed.unix // TODO verify and test
			},
			tags: null, // TODO implement TransactionTagDto first
			isIndex: item.is_index,
			isCard: item.is_card
		};
	}
}
